/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/auth/hooks/useAuth";
import { CmsConfig } from "../config";

const useAlerts = () => {

    const { token } = useAuth();
    const [liveAlert, setLiveAlert] = useState();
    const [previewAlert, setPreviewAlert] = useState();
    const [alertLoaded, setAlertLoaded] = useState(false);

    const loadLiveAlert = async function () {
        const _alert = await SimpliCitySDK.alert.findCurrent(token);
        if (!!_alert) {
            setLiveAlert(_alert);
            setAlertLoaded(true);
        }
    }

    const loadPreviewAlert = async function () {
        const _alert = await SimpliCitySDK.alert.findCurrentPreview(token);
        if (!!_alert) {
            setPreviewAlert(_alert);
        }
    }

    const loadAlerts = async function () {
        if (CmsConfig.isPreview) {
            await loadPreviewAlert()
        } else {
            await loadLiveAlert()
        }
        setAlertLoaded(true);
    }

    return {
        loadAlerts,
        liveAlert,
        previewAlert,
        alertLoaded
    }
}

export { useAlerts }
